module.exports = require("@swa-ui/dotcom/src/DotcomFooter/DotcomFooter.module.scss");